import React from 'react';
import ReactDom from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { initI18n } from '@utils/i18n';
import { I18n } from '@ies/starling_intl';
import { createClientStore } from '@redux/store';
import FastClick from 'fastclick';
import App from './App';
import smoothscroll from 'smoothscroll-polyfill';
import { AppInfoContext, Entry } from '@utils/index';
import { LangCode } from '@common/lang';
import { changeDayjsLocale } from '@utils/day';

smoothscroll.polyfill();

const store = createClientStore();
FastClick.attach(document.body);
const h5Info = {
    entry: Entry.H5,
};
const render = () => {
    ReactDom.hydrate(
        <Provider store={store}>
            <AppInfoContext.Provider value={h5Info}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </AppInfoContext.Provider>
        </Provider>,
        document.querySelector('#root'),
    );
};

initI18n().then(() => {
    // initial config dayjs for client rendering locale time format
    changeDayjsLocale(I18n.language as LangCode);
    render();
});
